import dayjs from 'dayjs';

export function isRecentScan(scanDateString: string): boolean {
  if (scanDateString) {
    // Parse the input date string using Day.js
    const scanDate = dayjs(scanDateString);

    // Get the current date
    const now = dayjs();

    // Calculate the difference in days
    const daysDifference = now.diff(scanDate, 'day');

    // Return true if the difference is 0 to 6 days (i.e., within the last 7 days)
    return daysDifference >= 0 && daysDifference < 7;
  }
  return false;
}
